var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGym(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 80",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "_") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5,29H6.5v6H5a1.003,1.003,0,0,1-1-1V30A1.003,1.003,0,0,1,5,29Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,29H42v6H22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,30v4a1.003,1.003,0,0,1-1,1H57.5V29H59A1.003,1.003,0,0,1,60,30Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5,21.05v21.9A1.01918,1.01918,0,0,1,54.51,44H52V20h2.51A1.01914,1.01914,0,0,1,55.5,21.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,16.97V47.03a1.0887,1.0887,0,0,1-1.18.97H45.18A1.0887,1.0887,0,0,1,44,47.03V16.97A1.0887,1.0887,0,0,1,45.18,16h3.64A1.0887,1.0887,0,0,1,50,16.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,20V44H9.49a1.01918,1.01918,0,0,1-.99-1.05V21.05A1.01914,1.01914,0,0,1,9.49,20Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,16.97V47.03a1.0887,1.0887,0,0,1-1.18.97H15.18A1.0887,1.0887,0,0,1,14,47.03V16.97A1.0887,1.0887,0,0,1,15.18,16h3.64A1.0887,1.0887,0,0,1,20,16.97Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGym);
export default __webpack_public_path__ + "static/media/gym.ba2d54c227a9b020d04e6b2bfba8651b.svg";
export { ForwardRef as ReactComponent };